export type Brand<TValue, TBrand extends string> = TValue & {
  readonly __brand: TBrand;
};

export interface SurveyDataManagerApiError {
  readonly status: number;
  readonly code?: string;
  readonly message: string;
  readonly details?: Readonly<Record<string, unknown>>;
}

export const SURVEY_DATA_MANAGER_TENANT_HEADER = 'X-Tenant-Id';

export interface SurveyDataManagerTenantContext {
  readonly tenantId: string;
}
